import { render, staticRenderFns } from "./mobile-footer.vue?vue&type=template&id=f17e0f52&scoped=true"
import script from "./mobile-footer.vue?vue&type=script&lang=js"
export * from "./mobile-footer.vue?vue&type=script&lang=js"
import style0 from "./mobile-footer.vue?vue&type=style&index=0&id=f17e0f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17e0f52",
  null
  
)

export default component.exports